<template>
    <div>
        <el-dialog v-model="newDesignDialogVisible"
                   width="30%"
                   align-center>

            <template #header>
                <div class="head">
                    {{$t('newDesignPrompt.tittle')}}
                </div>
            </template>

            <template #default>
                <div class="body">
                    {{$t('newDesignPrompt.messagePart1')}}<b class="red">LoopWord</b>{{$t('newDesignPrompt.messagePart2')}}
                </div>
            </template>

        </el-dialog>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { navigationService } from '@/services/navigationService'
    import { userSettingsService } from '@/services/userSettingsService'

    export default defineComponent({
        created(){
            this.init();
        },
        data() {
            return {
                newDesignDialogVisible: false,
                userSettingsService: new userSettingsService(),
            };
        },
        computed: {
            homePage(): boolean {
                return this.$route.name == navigationService.homePageName
            },
        },
        methods:{
            async init() {
                if (!this.homePage) {
                    return;
                }

                const hasSeenDesign = await this.userSettingsService.getHasSeenDesignUpdate();
                if (hasSeenDesign == false) {
                    this.showDialog();
                    await this.userSettingsService.markDesignUpdateSeen()
                    return;
                }
            },
            showDialog() {
                this.newDesignDialogVisible = true;
            },

        }
    })
</script>

<style lang="scss" scoped>
    .body {
        font-size: 18px;
        margin: 25px 40px;
        line-height: 26px;

        b.red {
            color: var(--brand-red);
        }
    }
</style>